import React, { Component } from 'react';
import styles from './index.css';


export default class Tabs extends Component {

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.tabsContainer}>
          <div className={styles.tabs}>
            <div className={this.props.active === 0 ? styles.tabsActiveItem : styles.tabsItem} onClick={()=>this.props.setTabs(0)}>ЕЛЕВАТОР</div>
            <div className={this.props.active === 1 ? styles.tabsActiveItem : styles.tabsItem} onClick={()=>this.props.setTabs(1)}>ОБРОБКА ЗАПИТІВ</div>
            <div className={this.props.active === 2 ? styles.tabsActiveItem : styles.tabsItem} onClick={()=>this.props.setTabs(2)}>ПЛАНОВІ ПОКАЗНИКИ</div>
            <div className={this.props.active === 3 ? styles.tabsActiveItem : styles.tabsItem} onClick={()=>this.props.setTabs(3)}>ФІНАНСОВІ ПОКАЗНИКИ</div>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/shared/components/Tabs/index.js